import AbstractComponent from "./abstract-component";

const getFavoriteTitle = (isCheck) => isCheck ? `Удалить из избранного` : `Добавить в избранное`;


const createTemplate = (className, isCheck) => {
  return (
    `<button type="button" class="${className}__favorites favorites" data-is-check="${isCheck}" title="${getFavoriteTitle(isCheck)}">
      <svg  width="20" height="20" aria-hidden="true">
        <use class="stroke" href="sienge/img/sprite.svg#icon-favorite-stroke"></use>
        <use class="fill" href="sienge/img/sprite.svg#icon-favorite-fill"></use>
      </svg>
    </button>`
  );
};

export default class FavoriteComponent extends AbstractComponent {
  constructor({className = ``, isCheck = false}) {
    super();

    this._className = className;
    this._isCheck = isCheck;
    this._update = this._update.bind(this);
  }

  getTemplate() {
    return createTemplate(this._className, this._isCheck);
  }

  setClickHanlder(handler) {
    this.getElement().addEventListener(`click`, () => {
      this.getElement().dataset.status = `waiting`;
      handler(this._update);
    });
  }

  _update(isCheck) {
    this.getElement().dataset.status = `ready`;

    this.getElement().dataset.isCheck = isCheck;
    this.getElement().title = getFavoriteTitle(isCheck);
  }
}
